const queueByFolderId = new Map<string, Promise<void>>()

/**
 * Runs `task` after any previously queued task for the same `folderId` has settled, so
 * concurrent operations targeting the same folder (e.g. two nested-folder groups that resolve
 * to the same folder id) don't both act on a stale snapshot and collide.
 */
export function runSerializedForFolder(folderId: string, task: () => Promise<void>): Promise<void> {
  const previous = queueByFolderId.get(folderId) ?? Promise.resolve()
  const next = previous.then(task, task)
  queueByFolderId.set(folderId, next)
  next
    .finally(() => {
      if (queueByFolderId.get(folderId) === next) {
        queueByFolderId.delete(folderId)
      }
    })
    .catch(() => {
      // Cleanup itself can't fail here; this only exists so a rejected `task` doesn't also
      // surface as an unhandled rejection on this internal chain. Callers still observe the
      // rejection via the `next` promise returned below.
    })
  return next
}
